import store from '@src/store';

/**
 * Vue Router `beforeEnter` guard factory. Fetches org permissions from the
 * core Vuex module and redirects to `fallbackName` when the boolean
 * `OrganizationInfo` field named `settingName` is not truthy.
 *
 * Used by Capital Markets Pro feature routes (Spreads today; Par Rate
 * Calculator and Base Price Smoothing will adopt it in APP-30084/85) to
 * gate direct-URL access.
 *
 * On a rejected permissions dispatch, forwards the error to `next(err)` so
 * Vue Router aborts navigation and triggers `router.onError` rather than
 * leaving the transition hung.
 */
export function orgSettingGuard(settingName, fallbackName = 'pricing-details') {
  return (to, _, next) =>
    store
      .dispatch('core/getPermissions')
      .then(permissions => {
        if (permissions?.org?.[settingName]) {
          next();
        } else {
          next({ name: fallbackName, params: { id: to.params.id } });
        }
      })
      .catch(err => next(err));
}
